<template>
    <li>
        <a v-bind:href="item.Url.replace('~/','/')" v-bind:title="item.Title">
            <div class="person-listing-image">
                <img v-if="item.Image != ''" v-bind:src="item.Image" v-bind:alt="item.Title">
                <img v-if="item.Image == ''" src="/Content/images/person-avatar.png" v-bind:alt="item.Title">
            </div>
            <div class="person-listing-text">
                <p class="person-name">{{item.Title}}</p>
                <span v-if="item.BoardTitle != ''" class="person-title">{{item.BoardTitle}}</span>
                <span v-else class="person-title"></span>
                <p v-if="item.SmerpTitle != ''" class="person-title">{{item.SmerpTitle}}</p>
                <p v-else="item.JobTitle != ''" class="person-title">{{item.JobTitle}}</p>
                <div v-if="item.AcademicAffiliations" v-html="item.AcademicAffiliations"></div>
                <p v-else="item.Org != ''">{{item.Org}}</p>
            </div>
        </a>
    </li>
</template>

<script>
    export default {
        props: ['item'],
    }
</script>